import { forwardRef, InjectionToken, Type } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export interface ValueAccessorProvider {
  provide: InjectionToken<ControlValueAccessor>;
  useExisting: Type<any>;
  multi: boolean;
}

/**
 * Creates provider that:
 * Register the component by pushing it to the global NG_VALUE_ACCESSOR provider.
 *
 * @param type type of the component
 * @return provider for the given type
 * */
export function valueAccessorFactory(type: Function): ValueAccessorProvider {
  return {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => type),
    multi: true
  };
}
